(() => {
  if (customElements.get('pc-photo-menu')) return;
  customElements.define('pc-photo-menu', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      if (!this.details || !this.trigger) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const on = (node, type, fn, extra = {}) => node.addEventListener(type, fn, { signal: this.controller.signal, ...extra });
      on(this.details, 'toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) {
          if (innerWidth < 1000) { this.close(); return; }
          this.position();
          document.querySelectorAll('pc-photo-menu, pclan-mega-menu, pclan-top-dropdown').forEach(menu => {
            if (menu === this) return;
            if (typeof menu.close === 'function') menu.close();
            else { const details = menu.querySelector('details'); if (details) details.open = false; }
          });
        }
      });
      on(this, 'pointerenter', () => {
        clearTimeout(this.timer);
        if (this.dataset.hover === 'hover' && matchMedia('(hover: hover) and (pointer: fine)').matches) this.open();
      });
      on(this, 'pointerleave', () => {
        this.timer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 260);
      });
      on(this, 'focusout', () => queueMicrotask(() => {
        if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
      }));
      on(this.querySelector('.pc-photo-backdrop'), 'click', () => this.close(true));
      on(document, 'pointerdown', e => { if (!this.contains(e.target)) this.close(); });
      on(document, 'keydown', e => {
        if (e.key === 'Escape' && this.details.open) { e.preventDefault(); this.close(true); }
      });
      on(document, 'toggle', e => {
        if (e.target !== this.details && e.target.open && e.target.closest?.('pclan-mega-menu, pclan-top-dropdown, pc-photo-menu')) this.close();
      }, { capture: true });
      on(window, 'resize', () => { if (this.details.open) this.position(); });
      on(window, 'scroll', () => { if (this.details.open) this.position(); }, { passive: true });
      on(document, 'shopify:block:select', e => { if (e.target.contains(this)) this.open(); });
      on(document, 'shopify:block:deselect', e => { if (e.target.contains(this)) this.close(); });
      this.trigger.setAttribute('aria-expanded', String(this.details.open));
      if (this.details.open) this.position();
    }
    open() {
      if (innerWidth < 1000) return;
      clearTimeout(this.timer);
      this.position();
      this.details.open = true;
    }
    close(focus = false) {
      clearTimeout(this.timer);
      if (this.details) this.details.open = false;
      if (focus) this.trigger.focus({ preventScroll: true });
    }
    position() {
      if (innerWidth < 1000) { this.close(); return; }
      const nav = this.closest('.nav-bar');
      const rect = this.trigger.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= innerHeight) { this.close(); return; }
      const top = Math.ceil(Math.max(rect.bottom, nav?.getBoundingClientRect().bottom || 0)) + (Number(this.dataset.gap) || 0);
      const width = Math.min(parseFloat(getComputedStyle(this).getPropertyValue('--pc-photo-width')) || 1440, innerWidth - 32);
      const list = nav?.querySelector('.nav-bar__linklist');
      const left = this.dataset.position === 'center' ? (innerWidth - width) / 2 : (list?.getBoundingClientRect().left ?? rect.left);
      this.style.setProperty('--pc-photo-top', `${top}px`);
      this.style.setProperty('--pc-photo-left', `${Math.max(16, Math.min(left, innerWidth - width - 16))}px`);
      this.style.setProperty('--pc-photo-available', `${Math.max(0, innerHeight - top - 16)}px`);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
})();
